import lodash from 'lodash';

export const binderValidationSelector = state => lodash.get(state, 'binder.validation', {});
export const binderValidationLoadingSelector = state => lodash.get(binderValidationSelector(state), 'loading', false);
